<template>
    <div class="row">
        <div class="col-xs-12 col-md-6">
            <div class="swiper-container">
                <div class="swiper-wrapper">
                    <div class="swiper-slide">
                        <img class="toBeCropped" v-bind:src="product.images[0]">
                    </div>
                </div>
            </div>
            <div class="swiper-pagination"></div>
        </div>
        <div class="col-xs-12 col-md-6">
            <div id="qb-close" v-on:click="$emit('close-quick')"><i class="fal fa-times"></i></div>
            <div class="p-logo">
                <img src="/img/logo-pollini.jpg" alt="Pollini Retail Spa" />
            </div>
            <div class="p-name">{{ product.name }}</div>
            <div class="p-price">
                <span class="current_price" v-bind:class="{ discount: product.discount }" style="font-weight:500;">{{ (product.discountPrice>0 ? product.discountPrice : product.price) }} {{ product.currency }}</span>
                <span v-if="product.discount && product.priceList.includes(product.priceListId)==false" class="base_price strike">{{ (product.discountPrice>0 ? product.price : null) }}  {{ product.currency }}</span>
                 <span v-if="product.discount && product.priceList.includes(product.priceListId)" class="p-name" style="color: #333; font-size: 14px; line-height: normal; display: block; margin-top: 0px; text-transform: none;"> {{ strings['lower_price_last_days'] }} {{ product.lower_price }} {{ product.currency }} {{(product.discountPercentageLowerPrice <0 ? '('+product.discountPercentageLowerPrice.toString()+'%)'  : '')}} </span>
                 <span v-if="product.discount && product.priceList.includes(product.priceListId)" class="p-name" style="color: #333; font-size: 14px; line-height: normal; display: block; margin-top: 0px; text-transform: none; margin-bottom:10px;"> {{ strings['publishing_price'] }} {{ product.original_price }} {{ product.currency }} ({{ product.discountPercentageOriginalPrice }}%)</span>
            </div>
            <div class="p-description">{{ product.description }}</div>
            <div v-if="product.skus !== null && !product.singleSku" class="p-sizes">
                <div class="header">
                    <span class="h-text">{{ strings['product_detail_choos_size'] }}</span>
                </div>
                <div class="sizes">
                    <ul>
                        <li v-for="(sku, keySku) in product.skus" :key="keySku" class="sku" v-bind:class="{selected: selected === sku.id }" v-on:click="active(sku.id)">{{ sku.size }}</li>
                    </ul>
                </div>
            </div>
            <div v-else-if="product.skus !== null" :set="selected = product.skus.id" class="sku selected hidden" >{{ product.skus.size }}</div>
            <div class="actions" data-toggle="tooltip" data-placement="bottom" v-bind:title="strings['choose_size']">
                <button type="cart" name="button" class="bttn quicky" v-on:click="add" v-bind:disabled="selected === null" >
                    <span v-if="wishlist == false" class="btn-label">{{ strings['add_to_cart'] }}</span>
                    <span v-else class="btn-label">{{ strings['add_to_wishlist'] }}</span>
                </button>
            </div>
            <div class="wishlist-msg pt3">{{ message }}</div>
        </div>
    </div>
</template>

<script>
import Swal from 'sweetalert2/dist/sweetalert2.js'

export default {
    props: ['product', 'strings', 'wishlist'],
    data: function () {
        return {
            selected: null,
            message: '',
        }
    },
    watch: {
        product: function(newVal, oldVal) { // watch it
            if(newVal.id != oldVal.id) {
                this.selected = null
                this.message = ''
            }
        }
    },
    methods: {
        active(id) {
            this.selected = id
        },
        add() {
            if(this.wishlist) {
                window.axios.post(window.PlUs.api.wishlist, {
                    'id': this.selected,
                    'type': 'sku'
                })
                .then((response) => {
                    if(process.env.NODE_ENV === "development") {
                        console.log('addItemToWish', response)
                    }
                    if(response.data.data.added) {
                        this.message = window.PlUs.strings.product_added_to_wishlist
                        $(".wishlist-quantity").html(response.data.data.total)
                        $('.wish-list[data-product="'+this.product.id+'"]').addClass('active')

                        // fbq('track', 'AddToWishlist', {
                        //     value:  $(this).attr('data-price'),
                        //     currency: $(this).attr('data-currency'),
                        //     content_ids: 'PRODUCT_GROUP_ID',
                        //     content_type: 'product_group'
                        // });
                    } else {
                        Swal.fire({
                            icon: 'info',
                            title: 'Oops...',
                            text: response.data.data.message,
                        })
                    }
                }).catch((err) => {
                    console.error(err)
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: this.strings['error'],
                        footer: err
                    })
                })
            } else {
                window.Quicktrue=1;
                window.Cart.addItem(
                    this.selected,
                    this.product.price,
                    this.product.currency,
                    this.product.id
                )
                this.$emit('close-quick')
            }

        }
    }
}
</script>
